import { Link } from "react-router-dom";
import PageRoutes from "@/utils/constants";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/v2/components/ui/dialog";

export function DownloadUpsellDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Downloads are a subscriber perk</DialogTitle>
          <DialogDescription>
            It looks like you're trying to initiate a download. Downloads are
            available to subscribers. Head over to the{" "}
            <Link
              to={PageRoutes.Packages}
              className="text-action font-semibold hover:underline"
            >
              Plans
            </Link>{" "}
            tab to subscribe and then try your download again.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
